import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { z } from 'zod';
import { ReferralsTab } from '@/pages/ReferralsTab/ReferralsTab.tsx';
import { referralsInfiniteQueryOptions } from '@/pages/ReferralsTab/api/referrals.api.ts';
import { getAccountantExternalId } from '@/contexts/accountantExternalId.ts';

const defaultValues = {
  search: '',
} as const;

const searchSchema = z.object({
  search: z.string().default(defaultValues.search).catch(defaultValues.search),
});

export const Route = createFileRoute('/_index/referrals')({
  component: ReferralsTab,
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  loader: ({ context }) => {
    const externalId = getAccountantExternalId();
    if (externalId) {
      return context.queryClient.ensureInfiniteQueryData(referralsInfiniteQueryOptions(externalId));
    }
  },
});
